module.exports = __webpack_public_path__ + "icons/original/small/small-c5.9254afe6e7940800db50da758cb752df.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-c5.png
// module id = AQov
// module chunks = app